<template>
    <ui-modal title="Update flags" :close="close">
        <ui-form-section class="mt-6">
            <ui-field label="Flags">
                <div class="grid gap-4 grid-cols-3">
                    <button
                        v-for="flag in flags"
                        :key="flag.value"
                        class="flex flex-col items-center justify-end h-full p-4 rounded-lg border"
                        :class="form[flag.value] ? 'bg-blue-50 border-blue-400' : 'bg-gray-50 border-transparent'"
                        @click="form[flag.value] = ! form[flag.value]"
                    >
                        <i
                            class="fa-fw text-base mb-1"
                            :class="[flag.icon, form[flag.value] ? 'text-gray-600' : 'text-gray-400']"
                        ></i>
                        <div
                            v-text="flag.label"
                            class="text-xs font-medium text-gray-500"
                            :class="form[flag.value] ? 'text-gray-800' : 'text-gray-500'"
                        ></div>
                    </button>
                </div>
            </ui-field>
            <ui-textarea autoresize rows="1" field="resize-none" label="Note" v-model="form.note" :error="form.errors.get('note')"></ui-textarea>
        </ui-form-section>
        <template #footer-primary>
            <ui-button-new primary class="w-full" :loading="form.busy" @click="form.submit()">Save</ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
import { keyBy, mapValues, pickBy, groupBy } from 'lodash'
import { Package } from '@models'
import { humanJoin } from '@utils'

export default {
    props: {
        close: Function,
        packageItem: Object,
    },
    data () {
        const initialData = {
            archive: this.packageItem.meta.archive,
            dead: this.packageItem.meta.dead,
            hold: this.packageItem.meta.hold,
            unable_to_quote: this.packageItem.meta.unable_to_quote,
            hot: this.packageItem.meta.hot,
            imminent: this.packageItem.meta.imminent,
            note: '',
        }

        return {
            flags: Package.updatableFlags(),
            form: new Form(initialData, async (form) => {
                if (! form.note) {
                    form.errors.errors.note = 'The note field is required.'
                    return
                }

                const changedStatement = this.getChangeStatement(form)
                await this.packageItem.updateFlags(form)
                if (changedStatement) {
                    await this.packageItem.addNote(changedStatement)
                }
                this.close()
            })
        }
    },
    methods: {
        getChangeStatement (form) {
            const changes = this.getChanges(form)
            let note = ''

            if (changes.added) {
                const addedFlags = changes.added.map(x => x.label)
                note += `Marked as ${humanJoin(addedFlags)}.`
            }

            if (changes.removed) {
                const removedFlags = changes.removed.map(x => x.label)
                const lineJump = note ? "\n" : ''
                note += `${lineJump}Unmarked as ${humanJoin(removedFlags)}.`
            }

            if (form.note) {
                const lineJump = note ? "\n" : ''
                note += lineJump + form.note
            }

            return note
        },
        getChanges (form) {
            const flags = keyBy(Package.updatableFlags(), 'value')
            const originalFlags = mapValues(flags, flag => {
                return this.packageItem.meta[flag.value] ?? false
            })
            const newFlags = mapValues(flags, flag => {
                return {
                    key: flag.value,
                    label: flag.label,
                    value: form[flag.value] ?? false,
                }
            })
            const changes = pickBy(newFlags, flag => {
                return originalFlags[flag.key] !== newFlags[flag.key].value
            })

            return groupBy(changes, change => change.value ? 'added' : 'removed')
        },
    },
}
</script>
